import clsx from "clsx";

const VARIANT_CLASSES = {
  panel: "bg-white shadow-card dark:bg-gray-800",
  outline: "bg-white border border-gray-200 dark:bg-gray-800 dark:border-gray-700",
};

const PADDING_CLASSES = {
  none: "",
  md: "p-4 sm:p-5",
};

// Matches DESIGN.md's Cards spec: rounded-card shape, single shadow-card elevation
// step (no deeper shadow variant exists). "outline" is the list-row style seen in
// Inventory.jsx (border, no shadow) — a real distinct role, not a fallback for panel.
export default function Card({
  variant = "panel",
  padding = "md",
  className,
  children,
  ...props
}) {
  return (
    <div
      className={clsx(
        "rounded-card",
        VARIANT_CLASSES[variant],
        PADDING_CLASSES[padding],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
